import _ from 'lodash';
import {loop, Effects} from 'redux-loop';

const mediaTypes = [
{
  name: '新聞',
  id: 'news',
}, {
  name: '微博',
  id: 'weibo',
},
{
  name: 'Facebook',
  id: 'facebook',
}, {
  name: '微信',
  id: 'wechat',
}, {
  name: 'YouTube',
  id: 'youtube'
}, {
  name: '痞客邦',
  id: 'pixnet'
}, {
  name: '論壇',
  id: 'forum',
}, {
  name: '論壇',
  id: 'forumComment',
}, {
  name: '視頻',
  id: 'video',
}, {
  name: '博客',
  id: 'blog',
}, {
  name: 'Instagram',
  id: 'instagram',
},
// {
//   name: '澳門講場',
//   id: 'macautalk',
// },
 {
  name: 'Twitter',
  id: 'twitter',
}, {
  name: '商品',
  id: 'goods',
}, {
  name: '專頁',
  id: 'page',
}, {
  name: '線下媒體',
  id: 'print',
}];

const initalState = {
  mediaTypeById: _.keyBy(mediaTypes, 'id'),
  mediaTypeIds: _.map(mediaTypes, 'id'),
};

const reducer = (state = initalState, action) => {
  return loop(state, Effects.none());
}

export default reducer;



/** WEBPACK FOOTER **
 ** ./src/app/modules/mediaType/reducer.js
 **/